import React, { useEffect, useState } from 'react'

import { getTokenValue } from 'tamagui'

import { Image } from '../Image'

import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withSpring,
  interpolate,
  Extrapolate,
  WithSpringConfig,
} from 'react-native-reanimated'

import logoImageBackground from './images/guild-icon-background.svg'
import logoIconRightTop from './images/guild-icon-right-top.svg'
import logoIconRightBottom from './images/guild-icon-right-bottom.svg'
import logoIconLeft from './images/guild-icon-left.svg'

export const LogoIconAnimated = Image.styleable<{
  animate?: boolean
  src?: undefined // we set our own src
}>(({ animate = false, width, height, ...props }, ref) => {
  const backgroundAnimation = useSharedValue(1)
  const leftAnimation = useSharedValue(1)
  const rightTopAnimation = useSharedValue(1)
  const rightBottomAnimation = useSharedValue(1)

  width = typeof width === 'string' && getTokenValue(width, 'size')
  height = typeof height === 'string' && getTokenValue(height, 'size')

  useEffect(() => {
    if (animate) {
      let inEffect = true

      const springOptions: WithSpringConfig = { damping: 1000 }

      const animation = async () => {
        return new Promise<void>((resolve) => {
          leftAnimation.value = withSpring(0)
          rightTopAnimation.value = withSpring(0)
          rightBottomAnimation.value = withSpring(0, {}, () => {
            leftAnimation.value = withSpring(1, springOptions, () => {
              rightBottomAnimation.value = withSpring(1, springOptions, () => {
                rightTopAnimation.value = withSpring(1, springOptions, () =>
                  resolve()
                )
              })
            })
          })
        })
      }

      const loop = async () => {
        while (inEffect) {
          // if (inEffect) {
          await animation()
          // }

          await new Promise<void>((resolve) => {
            setTimeout(() => {
              resolve()
            }, 2000)
          })
        }
      }

      loop()

      return () => {
        inEffect = false
      }
    }
  }, [animate])

  const backgroundStyle = useAnimatedStyle(() => {
    return {
      width,
      height,

      transform: [
        { scale: interpolate(backgroundAnimation.value, [0, 1], [1.5, 1]) },
      ],

      opacity: interpolate(
        backgroundAnimation.value,
        [0, 1],
        [0, 1],
        Extrapolate.CLAMP
      ),
    }
  }, [width, height])

  const leftStyle = useAnimatedStyle(() => {
    return {
      width,
      height,
      position: 'absolute',

      // transform: `translateX(${interpolate(
      //   leftAnimation.value,
      //   [0, 1],
      //   [size * -2, 0]
      // )}px) scale(${interpolate(leftAnimation.value, [0, 1], [1.5, 1])})`,
      opacity: interpolate(
        leftAnimation.value,
        [0, 1],
        [0, 1],
        Extrapolate.CLAMP
      ),
      filter: `blur(${interpolate(leftAnimation.value, [0, 1], [1, 0])}px)`,
    }
  }, [width, height])
  const rightTopStyle = useAnimatedStyle(() => {
    return {
      width,
      height,
      position: 'absolute',

      // transform: `translateY(${interpolate(
      //   rightTopAnimation.value,
      //   [0, 1],
      //   [size * -2, 0]
      // )}px) scale(${interpolate(rightTopAnimation.value, [0, 1], [1.5, 1])})`,
      opacity: interpolate(
        rightTopAnimation.value,
        [0, 1],
        [0, 1],
        Extrapolate.CLAMP
      ),
      filter: `blur(${interpolate(rightTopAnimation.value, [0, 1], [1, 0])}px)`,
    }
  }, [width, height])
  const rightBottomStyle = useAnimatedStyle(() => {
    return {
      width,
      height,
      position: 'absolute',

      // transform: `translateY(${interpolate(
      //   rightBottomAnimation.value,
      //   [0, 1],
      //   [size * 2, 0]
      // )}px) scale(${interpolate(
      //   rightBottomAnimation.value,
      //   [0, 1],
      //   [1.5, 1]
      // )})`,
      opacity: interpolate(
        rightBottomAnimation.value,
        [0, 1],
        [0, 1],
        Extrapolate.CLAMP
      ),
      filter: `blur(${interpolate(
        rightBottomAnimation.value,
        [0, 1],
        [1, 0]
      )}px)`,
    }
  }, [width, height])

  return (
    <Animated.View style={backgroundStyle}>
      <Animated.View style={{ width, height, position: 'absolute' }}>
        <Image
          src={logoImageBackground}
          style={{ width: '100%', height: '100%' }}
        />
      </Animated.View>

      <Animated.View style={leftStyle}>
        <Image src={logoIconLeft} style={{ width: '100%', height: '100%' }} />
      </Animated.View>

      <Animated.View style={rightTopStyle}>
        <Image
          src={logoIconRightTop}
          style={{ width: '100%', height: '100%' }}
        />
      </Animated.View>

      <Animated.View style={rightBottomStyle}>
        <Image
          src={logoIconRightBottom}
          style={{ width: '100%', height: '100%' }}
        />
      </Animated.View>
    </Animated.View>
  )
})
